"use client";

import Link from "next/link";
import React from "react";
import styles from "./key-apps.module.scss";
import GradientCursorFollower from "@/components/layout/gradient-cursor-follow/gradient-cursor-follower";
import { MdOutlineArrowOutward } from "react-icons/md";
import { KEY_APPS } from "@/constants/key-apps.constants";
import Image from "next/image";

const KeyApps = () => {
  return (
    <div className={styles.container} id={"key-apps"}>
      <div className={styles.textContent}>
        <div className={styles.header}>Key apps</div>
        <div className={styles.subheader}>Explore the essential features and standout tools that drive our ecosystem.</div>
      </div>
      <ul className={styles.tabContainer}>
        {KEY_APPS.map((app, index) => (
          <Link href={app.url} key={app.title + index}>
            <div className={styles.tab}>
              <GradientCursorFollower />
              <div className={styles.image}>
                <Image src={app.image} alt={app.title + "-image"} />
              </div>
              <div className={styles.content}>
                <div className={styles.title}>{app.title}</div>
                <div className={styles.description}>{app.description}</div>
              </div>
              <div className={styles.icon}>
                <MdOutlineArrowOutward size={30} />
              </div>
            </div>
          </Link>
        ))}
      </ul>
    </div>
  );
};

export default KeyApps;
